
import { useTranslation } from '@/contexts/TranslationContext';
import { useEffect, useState } from 'react';

export const useTranslate = () => {
  const { translateText, currentLanguage, settings } = useTranslation();

  const t = async (text: string): Promise<string> => {
    if (!settings?.is_active) return text;
    return await translateText(text);
  };

  return { t, currentLanguage, isActive: settings?.is_active };
};

// Hook para traducir texto de forma síncrona con estado
export const useTranslatedText = (originalText: string) => {
  const [translatedText, setTranslatedText] = useState(originalText);
  const { translateText, currentLanguage, settings } = useTranslation();

  useEffect(() => {
    const translateAsync = async () => {
      if (!settings?.is_active || currentLanguage === settings.default_language) {
        setTranslatedText(originalText);
        return;
      }
      
      // Log para debugging
      console.log('Traduciendo:', originalText, 'al idioma:', currentLanguage);
      
      try {
        const translated = await translateText(originalText);
        console.log('Resultado traducción:', translated);
        setTranslatedText(translated);
      } catch (error) {
        console.error('Translation error:', error);
        setTranslatedText(originalText);
      }
    };

    translateAsync();
  }, [originalText, currentLanguage, settings, translateText]);

  return translatedText;
};
